import styled from 'styled-components';
import { styles, mixins } from '4all-ui/styles';
import { fontStyle, getColSize, flexPosition } from './mixins';
import {
  MAIN_COLOR,
  GRAY_DARKER,
  FONT_SIZE_5,
  FONT_WEIGHT_NORMAL,
  FONT_WEIGHT_BOLD,
  FONT_SIZE_6,
  GRAY_MEDIUM,
  GRAY_LIGHTER,
  FONT_SIZE_3,
  DANGER_COLOR,
  FONT_SIZE_7,
  WHITE,
} from './variables';

export const GroupInfo = styled.div`
  width: 100%;
  > label {
    ${fontStyle(GRAY_DARKER, FONT_SIZE_5, FONT_WEIGHT_NORMAL)};
    width: 226px;
    ${props => props.labelStyles}
  }
  > p {
    ${fontStyle(GRAY_MEDIUM, FONT_SIZE_7, FONT_WEIGHT_BOLD)};
    width: 226px;
    margin-bottom: 15px;
    ${props => props.descStyles}
  }
  ${props => props.styles}
`;

export const Checkbox = styled.i`
  width: 18px;
  height: 18px;
  border: 2px solid ${GRAY_LIGHTER};
  background-color: ${({ disabled }) => (disabled ? GRAY_LIGHTER : WHITE)};
  border-radius: 3px;
  margin-right: 20px;
  position: relative;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  ${props =>
    props.someChecked
      ? `
    border-color: ${MAIN_COLOR};
    background-color: ${MAIN_COLOR};
    &:after {
      content: '';
      background-color: ${WHITE};
      width: 12px;
      height: 2px;
      border-radius: 3px;
      display: flex;
      position: absolute;
      top: 45%;
      left: 1px;
    }
    `
      : null}
  ${props =>
    props.checked
      ? `
    border-color: ${MAIN_COLOR};
    background-color: ${MAIN_COLOR};
    &:after {
      content: '';
      top: 0;
      display: flex;
      position: absolute;
      left: 4px;
      background-color: transparent;
      border-radius: 0;
      transform: rotate(45deg);
      height: 12px;
      width: 6px;
      border-bottom: 2px solid ${WHITE};
      border-right: 2px solid ${WHITE};
    }
    `
      : null}
`;

export const Button = styled.button`
  background-color: ${props =>
    props.customBackgroundColor ? props.customBackgroundColor : MAIN_COLOR};
  border: solid 1px ${props => (props.customBorderColor ? props.customBorderColor : MAIN_COLOR)};
  ${fontStyle(WHITE, FONT_SIZE_6, FONT_WEIGHT_BOLD)};
  height: 50px;
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 0;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-image: none;
  border-radius: 4px;

  &[disabled] {
    opacity: 0.65;
    cursor: not-allowed;
  }

  img {
    margin-right: 10px;
  }
`;

export const Box = styled.div`
  padding: ${({ noPadding }) => (noPadding ? 'unset' : '30px')};
  box-shadow: 0px 0px 10px 3px rgba(0, 0, 0, 0.05);
  background-color: ${WHITE};
  border-radius: 3px;
  width: ${({ size }) => (size ? getColSize(size) : '100%')};
  margin-right: ${({ colSpacing }) => (colSpacing ? `${colSpacing}px` : '0px')};
  ${({ customStyles }) => customStyles}
`;

export const TitleBox = styled.h2`
  ${fontStyle(GRAY_DARKER, FONT_SIZE_3, FONT_WEIGHT_NORMAL)}
  ${flexPosition({ align: 'center', justify: 'flex-start' })}
  margin: 0;
`;

export const DescBox = styled.p`
  ${fontStyle(GRAY_MEDIUM, FONT_SIZE_7, FONT_WEIGHT_BOLD)}
  margin: 0;
`;

export const Row = styled.div`
  width: 100%;
  ${flexPosition({ align: 'center' })}
  ${props => props.styles}
`;

export const FormGroup = styled.div`
  width: ${({ width }) => width || '100%'};
  > label {
    ${fontStyle(GRAY_MEDIUM, FONT_SIZE_6, FONT_WEIGHT_BOLD)};
    width: 100%;
    ${props => props.labelStyles}
  }

  textarea {
    border-radius: 3px;
    ${fontStyle(GRAY_DARKER, FONT_SIZE_6, FONT_WEIGHT_BOLD)};
    height: 45px;
    max-width: 100%;
    padding: 10px;
    width: 100%;
  }

  input,
  textarea {
    ${fontStyle(GRAY_DARKER, FONT_SIZE_6, FONT_WEIGHT_BOLD)};
    width: 100%;
    max-width: 100%;
    padding: 10px;
    height: 45px;
    border: 1px solid ${({ error }) => (error ? DANGER_COLOR : GRAY_LIGHTER)};
    border-radius: 3px;
    ${props => props.inputStyles}
  }

  textarea {
    height: auto;
  }
  ${props => props.styles}
`;

export const FormGroupCol = styled.div`
  width: ${({ width }) => width || '100%'};

  > label {
    ${mixins.fontStyle(
      styles.colors.GRAY_MEDIUM_3,
      styles.fontSizes.SIZE_7,
      styles.fontWeights.SEMIBOLD
    )};
    width: 100%;
    ${({ labelStyles }) => labelStyles}
  }

  input {
    height: 45px;
  }

  textarea {
    height: 106px;
  }

  input,
  textarea {
    ${({ inputStyles }) => inputStyles}
  }

  ${({ styles }) => styles}
`;



// WEBPACK FOOTER //
// ./src/styles/customComponents.js